<template>
  <div>
    <CoverBg
      show-text
      title="Blog"
    />
    <b-container class="main-container content-padding-t-b-100">
      <Loading v-if="loading" />
      <div
        v-else
      >
        <BlogCard
          v-for="(blog, i) in blogList"
          :key="i"
          :blog="blog"
        />
        <b-pagination
          v-if="totalRecords > 5"
          :value="page"
          :total-rows="totalRecords"
          :per-page="PAGE_SIZE"
          align="center"
          size="sm"
          pills
          @change="changePage"
        />
      </div>
      <h3
        v-if="!totalRecords && !loading"
        class="font-weight-bold text-center main-blue"
      >
        Blog page is empty
      </h3>
    </b-container>
    <ScrollToTop />
    <CoverBg
      bg="cover-bg-page-bottom"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import CoverBg from '@/components/CoverBg';
import BlogCard from '@/components/Blog/BlogCard';
import ScrollToTop from '@/components/ScrollToTop';
import Loading from '@/components/Loading';
import { scrollToTop } from '@/helpers/helpers';

const PAGE_SIZE = 5;

export default {
  name: 'Blog',
  components: {
    Loading,
    BlogCard,
    CoverBg,
    ScrollToTop,
  },
  data() {
    return {
      PAGE_SIZE,
      currentPage: 1,
      loading: false,
    };
  },
  computed: {
    ...mapState({
      blogList: (state) => state.blog.blogList,
      page: (state) => state.blog.page,
      totalRecords: (state) => state.blog.totalRecords,
    }),
  },
  beforeDestroy() {
    this.clearBlogData();
  },
  async created() {
    this.loading = true;
    await this.getBlogTotalRecords();
    await this.getBlogList({
      page: 1,
      itemsPerPage: PAGE_SIZE,
    }).then(() => {
      this.loading = false;
    }).catch(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions([
      'getBlogList',
      'getBlogTotalRecords',
      'clearBlogData',
    ]),
    async changePage(page) {
      scrollToTop();
      this.loading = true;
      await this.getBlogList({
        page,
        itemsPerPage: PAGE_SIZE,
      }).then(() => {
        this.loading = false;
      }).catch(() => {
        this.loading = false;
      });
    },
  },
};
</script>
